import {Box, List, Text} from '@mantine/core';
import type {FC} from 'react';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {getMailAuthLinkWithParamsHooks} from '../../../../../shared/services/getMailAuthLinkWithParamsHooks';

type Props = {
  title: string;
  description: string;
  reportType: 'selection' | 'intern' | 'entrysheet';
};

export const NoLoginReportModal: FC<Props> = ({
  title,
  description,
  reportType,
}) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});
  return (
    <Box className="relative">
      <Box className="absolute left-1/2 top-[600px] -translate-x-1/2 -translate-y-1/2 flex flex-col bg-white shadow-modal-lg p-16 py-20 rounded-16 w-11/12 pc:w-3/4 z-10">
        <Text className="font-bold text-2xl text-black-1 mb-8">{title}</Text>
        <Box>
          このレポートの続きを読むには、新規会員登録もしくはログインが必要です。
        </Box>
        <Box className="text-black-1 p-20">
          {reportType === 'selection' ? (
            <List spacing="sm">
              <List.Item className="font-bold">選考について</List.Item>
              <List withPadding className="list-disc list-inside">
                <List.Item className="text-base">エントリーシート</List.Item>
                <List.Item className="text-base">
                  筆記試験・WEBテスト・適性検査
                </List.Item>
                <List.Item className="text-base">面接</List.Item>
                <List.Item className="text-base">
                  その他の選考（インターン・ジョブ・グループディスカッション）
                </List.Item>
              </List>
              <List.Item className="font-bold">OB訪問について</List.Item>
              <List.Item className="font-bold">内定後について</List.Item>
              <List.Item className="font-bold">選考についての感想</List.Item>
              <Box className="flex flex-col gap-4 bg-line p-16 rounded-12 mt-8">
                <Text className="text-base">{description}...</Text>
              </Box>
            </List>
          ) : reportType === 'intern' ? (
            <List spacing="sm">
              <List.Item className="font-bold">選考について</List.Item>
              <List withPadding className="list-disc list-inside">
                <List.Item className="text-base">エントリーシート</List.Item>
                <List.Item className="text-base">
                  筆記試験・WEBテスト・適性検査
                </List.Item>
                <List.Item className="text-base">面接</List.Item>
                <List.Item className="text-base">
                  その他の選考（インターン・ジョブ・グループディスカッション）
                </List.Item>
              </List>
              <List.Item className="font-bold">
                インターンの内容について
              </List.Item>
              <List.Item className="font-bold">
                インターンについての感想
              </List.Item>
              <Box className="flex flex-col gap-4 bg-line p-16 rounded-12 mt-8">
                <Text className="text-base">{description}...</Text>
              </Box>
            </List>
          ) : (
            <List spacing="sm">
              <List.Item className="font-bold">1問目の回答</List.Item>
              <Box className="flex flex-col gap-4 bg-line p-16 rounded-12 mt-8">
                <Text className="text-base">{description}...</Text>
              </Box>
              <List.Item className="font-bold">2問目以降の設問と回答</List.Item>
            </List>
          )}
        </Box>
        <Box className="flex justify-center mt-16 gap-8">
          <CommonLink
            href={mailAuthLink}
            className="w-full text-white bg-gradient-to-r from-error to-sub font-bold text-center rounded-12 py-12"
          >
            新規会員登録
          </CommonLink>
          <CommonLink
            href="/login"
            className="w-full text-white bg-primary-1 font-bold text-center rounded-12 py-12"
          >
            ログイン
          </CommonLink>
        </Box>
      </Box>
    </Box>
  );
};
